import(/* webpackMode: "eager", webpackExports: ["Home"] */ "/app/sales-platform/portal/app/[locale]/component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/sales-platform/portal/components/layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/sales-platform/portal/components/Providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TranslationsProvider"] */ "/app/sales-platform/portal/components/TranslationsProvider.tsx");
